export const LimitScopeTypes = {
  LIMITED: "limited",
  UNLIMITED: "unlimited",
} as const;

export type LimitScopeType =
  typeof LimitScopeTypes[keyof typeof LimitScopeTypes];
